import styled from 'styled-components';

export const DivScrollBody = styled.div`
	height: '500px';
	overflow-X: 'auto';
	font-size: '14px';
	height: '500px';
	border: 1px solid black;
	padding: 50px;
`;
